import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import BreadCrumbs from "../layout/BreadCrumbs";
import { useSelector } from "react-redux";
import { Button, Card, Modal, Spin, Tooltip } from "antd";
import {
  FullscreenExitOutlined,
  FullscreenOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import PDFViewer from "./PDFViewer";
import Accelerators from "./Accelerators";

const NodePage = () => {
  const categories = useSelector((state) => state.data.categories);
  const sasUrls = useSelector((state) => state.data.sasUrls);
  const metadata = useSelector((state) => state.data.data);
  const [isFullscreen, setIsFullscreen] = useState(false);
  // const { parentPath } = useParams();
  const [parentPath, setParentPath] = useState("");
  const [pdfTitle, setPdfTitle] = useState("");
  const [openResponsive, setOpenResponsive] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [nodes, setNodes] = useState([]);
  const [clickReset, setClickReset] = useState(false);
  const [history, setHistory] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const baseUrl = "https://devxopsstor3563.blob.core.windows.net/";
  const [fullPath, setFullPath] = useState(baseUrl);
  const [loading, setLoading] = useState(true);
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [resetTrigger, setResetTrigger] = useState(false);
  const [showAccelerators, setShowAccelerators] = useState(false);

  const toggleChatWindow = () => {
    setIsChatOpen(!isChatOpen);
  };
  const toggleFullscreen = () => {
    setIsFullscreen(!isFullscreen);
  };

  useEffect(() => {
    setLoading(true);
    setShowAccelerators(false);
    // console.log("location.pathname:", location.pathname);
    let pathnames = location.pathname
      .split("/")
      .map((e) => decodeURIComponent(e))
      .slice(2)
      .join("/");
    setParentPath(
      location.pathname
        .split("/")
        .map((e) => decodeURIComponent(e))
        .slice(2)
        .join("/")
    );
    if (
      location.pathname ==
      "/node/capabilities/Accelerators/DevXOps%20Accelerators"
    ) {
      console.log("changes");
      setShowAccelerators(true);
      setLoading(false);
      return;
    }

    // console.log("location.pathname:", pathnames);
    if (metadata && metadata.length > 0) {
      // console.log("metadata:", metadata);
      setNodes([]);
      const newFullPath = pathnames
        ? `${baseUrl}${pathnames.replace(/ /g, "%20")}`
        : baseUrl;
      // console.log("newFullPath:", newFullPath);
      setFullPath(newFullPath);
      const newHistory = pathnames ? pathnames.split("/") : [];
      // console.log("newHistory:", newHistory);
      setHistory(newHistory);
      if (pathnames) {
        handleCardClick(metadata, pathnames, true);
      }
      setLoading(false);
    }
  }, [metadata, location.pathname]);
  const handleReset = () => {
    // console.log("inside handleReset");
    setResetTrigger((prev) => !prev);
  };
  const handleOpenPdfInNewTab = () => {
    if (selectedFile) {
      window.open(selectedFile, "_blank", "noopener,noreferrer");
    }
  };
  const handleDownloadPdf = () => {
    if (!selectedFile) {
      return;
    }

    const link = document.createElement("a");
    link.href = selectedFile;
    link.download = pdfTitle || "document.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const handleCardClick = (urls, filterString, isInitial = false) => {
    if (!urls) return;
    const clickedFile = urls.find(
      (item) => item.path && item.path.endsWith(filterString)
    );

    if (clickedFile && isFile(filterString)) {
      const matchedSasUrl = sasUrls.find(
        (item) => item.blob_path === clickedFile.path
      );

      if (matchedSasUrl) {
        setOpenResponsive(true);
        setSelectedFile(matchedSasUrl.sas_url);
      }
      return;
    }

    const filteredUrls = urls.filter(
      (item) => item.path && item.path.includes(filterString)
    );
    const transformedUrls = filteredUrls.map((item) => {
      const index = item.path.indexOf(filterString) + filterString.length;
      return item.path.slice(index + 1);
    });
    const resultSet = new Set(
      transformedUrls.map((url) => url.split("/")[0]).filter(Boolean)
    );
    const folders = [];
    const files = [];
    resultSet.forEach((node) => {
      if (isFile(node)) {
        files.push(node);
      } else {
        folders.push(node);
      }
    });

    folders.sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));
    files.sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));

    const sortedNodes = [...folders, ...files];
    // console.log("sortedNodes:", sortedNodes);
    const desiredOrderForTeamCharter = [
      "Core DevXOps.pdf",
      "Modern DevXOps (Containerization).pdf",
      "Platform Engineering.pdf",
      "DataOps_MLOps_LLMOps.pdf",
      "AI-Driven DevXOps.pdf",
      "APIOps.pdf",
      "Microsoft Operations.pdf",
      "Site Reliability Engineering.pdf",
    ];
    const desiredOrderForArchitecture = [
      "DevOps",
      "DevXOps",
      "ModernDevXOps",
      "DataOps",
      "MLOps",
      "IaC",
      "IAC",
      "APIOps",
    ];
    const desiredOrderForOfferings = [
      "DevXOps",
      "Modern DevOps",
      "DevSecOps",
      "DataOps-MLOps",
      "SRE",
      "Application Modernization",
      "IaC",
    ];
    const desiredOrderForBlog = [
      "DevXOps",
      "Platform Engineering",
      "DataOps-MLOps-LLMOps",
      "Generative AI",
      "IaC",
      "FinOps",
    ];
    const sortNotesOrder = (nodes, categories) => {
      let desiredOrder = [];
      if (categories == "Team Charter") {
        desiredOrder = desiredOrderForTeamCharter;
      } else if (categories == "Architecture") {
        desiredOrder = desiredOrderForArchitecture;
      } else if (categories == "Offerings") {
        desiredOrder = desiredOrderForOfferings;
      } else if (categories == "Blog") {
        desiredOrder = desiredOrderForBlog;
      }
      return [...nodes].sort((a, b) => {
        const indexA = desiredOrder.indexOf(a);
        const indexB = desiredOrder.indexOf(b);

        if (indexA !== -1 && indexB !== -1) {
          return indexA - indexB;
        }

        if (indexA !== -1) {
          return -1;
        }

        if (indexB !== -1) {
          return 1;
        }

        return 0;
      });
    };

    const sortedNotesOrder = filterString.endsWith("Team Charter")
      ? sortNotesOrder(sortedNodes || [], "Team Charter")
      : filterString.endsWith("Architecture")
      ? sortNotesOrder(sortedNodes || [], "Architecture")
      : filterString.endsWith("Offerings") ||
        filterString.endsWith("Service Offerings")
      ? sortNotesOrder(sortedNodes || [], "Offerings")
      : filterString.endsWith("Blogs")
      ? sortNotesOrder(sortedNodes || [], "Blog")
      : sortedNodes;
    // console.log("sortedNodes:", sortedNodes);
    // console.log("sortedNodes:", sortedNotesOrder);

    setNodes(sortedNotesOrder);

    if (!isInitial) {
      setHistory((prevHistory) => {
        if (prevHistory[prevHistory.length - 1] !== filterString) {
          return [...prevHistory, filterString];
        }
        return prevHistory;
      });
      setFullPath((prevFullPath) => {
        const newPath = `${prevFullPath}/${filterString}`.replace(/ /g, "%20");
        return newPath;
      });
    }
    setOpenResponsive(false);
    setSelectedFile(null);
  };

  const shortenSummary = (summary) => {
    if (!summary) return "";
    const maxLength = 60;
    if (summary.length > maxLength) {
      return summary.substring(0, maxLength) + "...";
    }
    return summary;
  };

  const handleNodeClick = (node) => {
    setLoading(true);
    const filterString = `${parentPath}/${node}`;
    console.log("filterString:", filterString);
    // console.log("parentPath:", parentPath);
    if (filterString === "capabilities/Accelerators/DevXOps Accelerators") {
      console.log("handleNodeClick");
      navigate(`/node/${parentPath}/${node}`);
      // setShowAccelerators(true);
      // setLoading(false);
      // return;
    }

    const clickedFile = metadata.find(
      (item) => item.path && item.path.endsWith(filterString)
    );

    if (node.endsWith(".pdf")) {
      setPdfTitle(node);
      if (clickedFile && isFile(filterString)) {
        const matchedSasUrl = sasUrls.find(
          (item) => item.blob_path === clickedFile.path
        );
        // console.log("matchedSasUrl:", matchedSasUrl);
        if (matchedSasUrl) {
          setOpenResponsive(true);
          setSelectedFile(matchedSasUrl.sas_url);
        }
        setLoading(false);
        return;
      }
      setPdfTitle(node);
    } else if (clickedFile?.link !== undefined) {
      window.open(clickedFile?.link, "_blank");
      setLoading(false);
      return;
    } else {
      if (parentPath.startsWith("capabilities/Certification")) {
        const fullNodePath = `${parentPath}/${node}`;
        const pathLength = fullNodePath.split("/").length;

        const filesInCertification = metadata.filter((data) => {
          return (
            data.path.startsWith(`${fullNodePath}/`) &&
            data.path.split("/").length === pathLength + 1
          );
        });
        const hasPdfInNextPath = filesInCertification.some((data) =>
          data.path.toLowerCase().endsWith(".pdf")
        );

        if (hasPdfInNextPath) {
          console.log(
            "Navigation prevented because a .pdf file exists directly under this folder."
          );
          setLoading(false);
          return;
        } else {
          navigate(`/node/${parentPath}/${node}`);
          handleCardClick(metadata, node);
          setLoading(false);
        }
        setLoading(false);
        return;
      } else {
        setLoading(false);
        navigate(`/node/${parentPath}/${node}`);
        handleCardClick(metadata, node);
      }
    }
    setLoading(false);
  };

  const isFile = (node) => {
    const fileExtensions = [".pdf", ".pptx", ".docx", ".xlsx", ".doc"];
    return fileExtensions.some((extension) => node.endsWith(extension));
  };

  const isClient = (nodeData) => {
    return nodeData && nodeData.path.startsWith("client/");
  };

  return (
    <div>
      <BreadCrumbs location={location} />
      {loading ? (
        <Spin
          indicator={
            <LoadingOutlined style={{ fontSize: 48, color: "#005BA1" }} spin />
          }
          tip="Loading..."
          fullscreen
        />
      ) : showAccelerators ? (
        <Accelerators />
      ) : nodes && nodes.length > 0 ? (
        <div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8 px-16 py-4">
            {nodes.map((node) => {
              {
                /* console.log("node:", node, " parentPath:", parentPath); */
              }
              const nodeData = metadata.find(
                (item) =>
                  item.path.endsWith(node) && item.path.startsWith(parentPath)
              );
              {
                /* console.log("nodeData:", nodeData); */
              }
              const matchedSasUrl = sasUrls.find(
                (item) => item.blob_path === nodeData?.iconimage
              );
              {
                /* console.log("matchedSasUrl:", matchedSasUrl); */
              }
              const imageUrl = matchedSasUrl ? matchedSasUrl.sas_url : null;

              return isClient(nodeData) ? (
                <div key={node}>
                  {isFile(node) ? (
                    <Card
                      hoverable
                      variant="borderless"
                      className="text-center h-52 flex flex-col items-center justify-center custom-card"
                      styles={{
                        body: {
                          justifyItems: "center",
                        },
                      }}
                      onClick={() => handleNodeClick(node)}
                    >
                      <div className="w-20 h-20 flex items-center justify-center mb-2 ">
                        {imageUrl && (
                          <img src={imageUrl} className="object-contain" />
                        )}
                      </div>

                      <h3 className="text-lg font-medium text-gray-700">
                        {nodeData.name_of_document}
                      </h3>

                      {nodeData && (
                        <div className="node-details">
                          <Tooltip
                            title={nodeData.summary}
                            placement="bottom"
                            color="#555555"
                          >
                            <p style={{ fontStyle: "60%" }}>
                              {shortenSummary(nodeData.summary)}
                            </p>
                          </Tooltip>
                          {isFile(node) && <></>}
                        </div>
                      )}
                    </Card>
                  ) : (
                    <Card
                      hoverable
                      variant="borderless"
                      className="text-center h-52 flex flex-col items-center justify-center custom-card"
                      styles={{
                        body: {
                          justifyItems: "center",
                        },
                      }}
                      onClick={() => handleNodeClick(node)}
                    >
                      <div className="w-44 h-44 flex items-center justify-center mb-2">
                        {imageUrl && (
                          <img src={imageUrl} className="object-contain" />
                        )}
                      </div>

                      {isFile(node) && (
                        <>
                          <h3 className="text-lg font-medium text-gray-700">
                            {nodeData.name_of_document}
                          </h3>
                        </>
                      )}
                      {nodeData && (
                        <div className="node-details">
                          <Tooltip
                            title={nodeData.summary}
                            placement="bottom"
                            color="#555555"
                          >
                            <p style={{ fontStyle: "60%" }}>
                              {shortenSummary(nodeData.summary)}
                            </p>
                          </Tooltip>
                          {isFile(node) && <></>}
                        </div>
                      )}
                    </Card>
                  )}
                </div>
              ) : (
                nodeData?.name_of_document && (
                  <div key={node}>
                    <Card
                      hoverable
                      variant="borderless"
                      className="text-center h-52 flex flex-col items-center justify-center custom-card"
                      styles={{
                        body: {
                          justifyItems: "center",
                        },
                      }}
                      onClick={() => handleNodeClick(node)}
                    >
                      {imageUrl && (
                        <div className="w-[7rem] h-auto flex items-center justify-center mb-2 ">
                          <img src={imageUrl} className="h-14 object-contain" />
                        </div>
                      )}
                      <h3 className="text-lg font-medium text-gray-700 mt-4">
                        {nodeData?.name_of_document}
                      </h3>
                      {nodeData && (
                        <div className="node-details">
                          {nodeData.path.startsWith(
                            "capabilities/Certification"
                          ) ? (
                            <h3
                              style={{ fontStyle: "60%" }}
                              className="text-sm font-medium text-gray-700"
                            >
                              {shortenSummary(nodeData.summary)}
                            </h3>
                          ) : (
                            <Tooltip
                              title={nodeData.summary}
                              placement="bottom"
                              color="#555555"
                            >
                              <p style={{ fontStyle: "60%" }}>
                                {shortenSummary(nodeData.summary)}
                              </p>
                            </Tooltip>
                          )}
                          {isFile(node) && <></>}
                        </div>
                      )}
                    </Card>
                  </div>
                )
              );
            })}
          </div>
        </div>
      ) : (
        <div className="flex justify-center items-center h-64">
          <p className="text-gray-500">No items found in this location</p>
        </div>
      )}

      {/* <Modal
        title={
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div>
              <span>{pdfTitle}</span>
            </div>
            <div>
              <FullscreenOutlined style={{ fontSize: "25px" }} />
            </div>
          </div>
        }
        width="80%"
        open={openResponsive}
        style={{ top: "20px" }}
        closable={false}
        onOk={() => setOpenResponsive(false)}
        onCancel={() => {
          handleReset();
          setOpenResponsive(false);
        }}
        footer={[
          <Button
            className="modal-button"
            key="back"
            onClick={() => setClickReset(!clickReset)}
            style={{ color: "#005BA1", borderColor: "#005BA1" }}
          >
            Reset View
          </Button>,
          <Button
            className="modal-button"
            key="back"
            onClick={() => setOpenResponsive(false)}
            style={{ color: "red", borderColor: "red" }}
          >
            Close
          </Button>,
        ]}
      >
        <div className="py-3">
          <div className="pdf-viewer-container w-full h-[70vh] ">
            <PDFViewer pdfBlobUrl={selectedFile} resetTrigger={resetTrigger} />
          </div>
        </div>
      </Modal> */}
      <Modal
        title={
          <div>
            <div style={{ fontSize: "12px", color: "#667085", textTransform: "uppercase", letterSpacing: "0.08em" }}>
              Document Preview
            </div>
            <div style={{ fontSize: "20px", fontWeight: 600, color: "#1f2937" }}>
              {pdfTitle}
            </div>
          </div>
        }
        width={"92vw"}
        centered
        style={{
          maxWidth: "1280px",
        }}
        styles={{
          header: {
            borderBottom: "1px solid #e5e7eb",
            marginBottom: 0,
            paddingBottom: "16px",
          },
          body: {
            height: "calc(100vh - 210px)",
            overflow: "hidden",
            background: "#f8fafc",
            padding: "20px",
          },
        }}
        open={openResponsive}
        onOk={() => setOpenResponsive(false)}
        onCancel={() => {
          handleReset();
          setOpenResponsive(false);
        }}
        footer={[
          <Button
            className="modal-button"
            key="open"
            onClick={handleOpenPdfInNewTab}
            style={{ color: "#005BA1", borderColor: "#005BA1" }}
          >
            Open in New Tab
          </Button>,
          <Button
            className="modal-button"
            key="download"
            onClick={handleDownloadPdf}
            style={{ color: "#005BA1", borderColor: "#005BA1" }}
          >
            Download PDF
          </Button>,
          <Button
            className="modal-button"
            key="reset"
            onClick={handleReset}
            style={{ color: "#005BA1", borderColor: "#005BA1" }}
          >
            Reset View
          </Button>,
          <Button
            className="modal-button"
            key="close"
            onClick={() => {
              handleReset();
              setOpenResponsive(false);
            }}
            style={{ color: "red", borderColor: "red" }}
          >
            Close
          </Button>,
        ]}
      >
        <div className="py-3">
          <div
            className="pdf-viewer-container"
            style={{
              width: "100%",
              height: "calc(100vh - 270px)",
            }}
          >
            <PDFViewer pdfBlobUrl={selectedFile} resetTrigger={resetTrigger} />
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default NodePage;
